import { render } from "./EventsGallery.vue?vue&type=template&id=95e439a2&scoped=true"
import script from "./EventsGallery.vue?vue&type=script&lang=js"
export * from "./EventsGallery.vue?vue&type=script&lang=js"

import "./EventsGallery.vue?vue&type=style&index=0&id=95e439a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e439a2"]])

export default __exports__